// extracted by mini-css-extract-plugin
export default {"landingContainer":"Landing_landingContainer__IUdT8"};